import {
    getFirestore,
    collection,
    getDocs,
    doc,
    updateDoc,
} from "firebase/firestore";

/**
 * Migration:
 * - garantit loges[]
 * - garantit fonctionsParLoge{} avec une cl� par loge
 * - copie l'ancien couple (loge + fonction) si possible
 * - ne met AUCUN r�le automatique: les loges inconnues restent � "".
 */
export async function migrateFonctionsParLoge(): Promise<{
    scanned: number;
    updated: number;
    skipped: number;
    errors: number;
}> {
    const db = getFirestore();
    const snap = await getDocs(collection(db, "Membres"));

    let scanned = 0;
    let updated = 0;
    let skipped = 0;
    let errors = 0;

    for (const d of snap.docs) {
        scanned++;

        try {
            const data: any = d.data();

            // 1) Construire logesArr (sans doublons)
            const logesArr: string[] = Array.isArray(data.loges)
                ? data.loges.filter(Boolean)
                : (data.loge ? [data.loge] : []);

            const uniqLoges = Array.from(new Set(logesArr));

            // 2) Construire map fonctionsParLoge existante (si elle existe)
            const existingMap: Record<string, string> =
                data.fonctionsParLoge && typeof data.fonctionsParLoge === "object"
                    ? { ...data.fonctionsParLoge }
                    : {};

            // 3) Copier l'ancien couple (loge + fonction) si on l'a et si absent
            if (data.loge && typeof data.loge === "string") {
                if (
                    data.fonction &&
                    typeof data.fonction === "string" &&
                    !(data.loge in existingMap)
                ) {
                    existingMap[data.loge] = data.fonction;
                }
            }

            // 4) S'assurer qu'il y a une entr�e pour chaque loge (valeur "" si inconnue)
            let changed = false;

            for (const l of uniqLoges) {
                if (!(l in existingMap)) {
                    existingMap[l] = ""; // <-- vide, � compl�ter ensuite
                    changed = true;
                }
            }

            // 5) Si loges �tait absent ou diff�rent => update
            const needLogesUpdate =
                !Array.isArray(data.loges) ||
                JSON.stringify(uniqLoges) !== JSON.stringify(data.loges);

            // 6) Si fonctionsParLoge �tait absent/diff�rent => update
            const needMapUpdate =
                JSON.stringify(existingMap) !==
                JSON.stringify(data.fonctionsParLoge || {});

            if (!needLogesUpdate && !needMapUpdate) {
                skipped++;
                continue;
            }

            const payload: any = {};
            if (needLogesUpdate) payload.loges = uniqLoges;
            if (needMapUpdate) payload.fonctionsParLoge = existingMap;

            await updateDoc(doc(db, "Membres", d.id), payload);
            updated++;
        } catch (e) {
            errors++;
            console.error("Migration error for doc:", d.id, e);
        }
    }

    return { scanned, updated, skipped, errors };
}
